import { Component, OnInit } from '@angular/core';
import { UntypedFormGroup, UntypedFormBuilder, UntypedFormControl, Validators } from '@angular/forms';
import { DataService, AuthService } from 'src/app/shared/services';
import { BsModalRef } from 'ngx-bootstrap/modal';
import * as _ from 'lodash';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-custom-criteria-edit',
  templateUrl: './edit.component.html'
})
export class CustomCriteriaEditComponent implements OnInit {
  // Modal parameters
  items: any; // array of items to edit

  // form instance
  form!: UntypedFormGroup;

  // Usage mode
  mode: ('mass' | 'single') = 'single';

  // Target Id's
  targetIds: number[] = [];

  // UI Flag
  isLoading = false;
  data = null;
  isSubmitted = false;
  showValidationError = false;
  isEmptyField = false;

  // Form reference Data
  parentReference: any;

  /**
   * @param formBuilder
   * @param service
   * @param auth
   * @param bsModalRef
   * @param translate
   */
  constructor(
    private formBuilder: UntypedFormBuilder,
    protected service: DataService,
    public auth: AuthService,
    public bsModalRef: BsModalRef,
    public translate: TranslateService
  ) {
    this.isLoading = true;
  }

  /**
   *
   */
  async ngOnInit(): Promise<void> {

    // Sniff mode
    this.mode = this.sniffEditMode(this.items);

    // get target Ids
    this.targetIds = _.map(this.items, el => el.custom_criteria_id);

    // Get default empty object
    if (this.mode === 'mass') {
      this.items = [{
        account: this.auth.getAccountId(),
      }];
    }

    // Build for
    this.form = this.getForm(this.items[0]);

    // Loading done !
    this.isLoading = false;
  }

  /**
   * Sniff usage mode from items configuration
   */
  sniffEditMode(items: [any?]): ('mass' | 'single') {
    // Empty array => New Item
    if (items !== undefined && items.length === 1) {
      return 'single';
    }
    return 'mass';
  }

  /**
   *
   */
  getForm(item: any): UntypedFormGroup {
    return this.formBuilder.group({
      id: new UntypedFormControl(item.custom_criteria_id),
      value: new UntypedFormControl(item.custom_criteria_value, [Validators.required, Validators.pattern(/^(\s+\S+\s*)*(?!\s).*$/)]),
    });
  }

  /**
   * Confirm callback with updated res
   */
  confirmFn = (res: any) => { };


  /**
   * Empty a field and mark it as dirty
   * @param fieldName
   */
  setEmpty(fieldName: string): void {
    this.form.get(fieldName)?.setValue(null);
    this.form.get(fieldName)?.markAsDirty();
    this.isEmptyField = true;
  }

  /**
   *
   */
  save(): boolean | void {
    this.showValidationError = true;
    if (!this.form || (this.form && !this.form.valid && !this.isEmptyField)) {
      return false;

    } else {

      // Query pointer
      let query;

      if (this.mode === 'single') {
        query = this.service.update('api/fastpm/custom-criteria', this.targetIds[0], this.form.value);
      } else {
        const tmpData: any = {};
        _.each(this.form.controls, (control, name) => {
          if (control.dirty === true && control.value !== -1) {
            tmpData[name] = control.value;
          }
        });
        const data = _.map(this.targetIds, id => {
          const cloned = _.cloneDeep(tmpData);
          _.merge(cloned, { id });
          return cloned;
        });

        query = this.service.saveAll('api/fastpm/custom-criteria', data);
      }

      this.isSubmitted = true;
      query?.subscribe(res => {
        this.isSubmitted = false;
        this.confirmFn(res);
        this.bsModalRef.hide();
      }, err => {
        console.log('err: ', err);
        this.isSubmitted = false;
      });
    }
  }
}
